<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" hide-required-asterisk>
      <form-box :title="$t('hzmbG.title.application')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.approveNo')">
                <el-input v-model="form.approveNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.registrationNo')">
                <el-input v-model="form.registrationNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.identificationNo')">
                <el-input v-model="form.identificationNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.mobile')" prop="mobile">
                <div class="m-mobile_row">
                  <el-select v-model="form.mobileAreaCode" disabled>
                    <el-option
                      v-for="item in areas"
                      :key="item.value"
                      :value="item.value"
                      :label="item.text"
                    ></el-option>
                  </el-select>
                  <el-input v-model="form.authMobile" disabled></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <form-box :title="$t('hzmbG.title.cancelDescription')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="24">
              <el-form-item
                :label="$t('hzmbG.label.cancelReason')"
                prop="cancelReason"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select v-model="form.cancelReason">
                  <el-option
                    v-for="(item, i) in reasons"
                    :key="i"
                    :label="item[`name${$t('message.lan')}`]"
                    :value="item[`name${$t('message.lan')}`]"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
    </el-form>
    <div class="next_btn">
      <GradientBtn @click="onSubmit" :loading="submitLoading"
        >{{ $t("message.confirm_submit") }}
      </GradientBtn>
    </div>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import FormBox from "../components/FormBox.vue";
import GradientBtn from "@/components/GradientBtn.vue";
import HzmbGCancelApplicationAPI from "@/api/hzmb-gh/HzmbGCancelApplicationAPI";
import ReasonTemplateAPI from "@/api/hzmb-gh/ReasonTemplateAPI";
export default {
  components: { FormBox, GradientBtn },
  data() {
    return {
      serviceType: this.$route.meta.serviceType,
      applicationId: this.$route.params.applicationId,
      loading: false,
      form: {
        vehicle: {},
      },
      verifyForm: {},
      submitLoading: false,
      reasons: [],

      areas: [
        { value: "853", text: i18n.t("hzmbG.enum.areas.macau") },
        { value: "852", text: i18n.t("hzmbG.enum.areas.hongkong") },
      ],
    };
  },
  methods: {
    async get() {
      try {
        this.loading = true;
        let form = await HzmbGCancelApplicationAPI.getById(this.applicationId);
        this.reasons = await ReasonTemplateAPI.getReasons(this.serviceType);
        this.$set(this, "form", form);
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.doSubmit();
        } else {
          this.$message({
            type: "error",
            message: this.$t("message.form_error"),
          });
        }
      });
    },
    async doSubmit() {
      try {
        this.submitLoading = true;
        const { id, cancelReason } = this.form;
        const { applicationNo } = await HzmbGCancelApplicationAPI.submit(
          id,
          cancelReason
        );
        this.$router.push({
          path: "/hzmb-g-cancel/success",
          query: {
            applicationNo,
            id,
          },
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
  },
  created() {
    this.verifyForm = JSON.parse(localStorage.getItem("verifyForm")) || {};
    this.get();
  },
};
</script>

<style lang="scss" scoped>
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
</style>
